// NEMOS screen help (the "?" at the top of NEMOS). Plain words; keep it in step with
// the screen (apps/mobile/src/tools/NemosTool.tsx and tools/nemos/*): section names,
// buttons and labels must match.
import type { ScreenHelpContent } from '../../v10/ScreenHelp';

export const nemosHelp: ScreenHelpContent = {
  title: 'N.E.M.O.S',
  intro:
    'N.E.M.O.S is your filing cabinet. Give everything a home and get it back fast. It has four sections, switched with the buttons under the title: Notes, Files, Records and Recall.',
  sections: [
    {
      heading: 'Notes',
      body: ['For things you write. Notes live inside folders.'],
      items: [
        { term: '+ Folder', text: 'type a name and press Save. Tap a folder to open it, and tap it again to close it. Long-press a folder to rename it.' },
        { term: '+ Note', text: 'adds a note to the folder you have open. It stays greyed out until you open a folder.' },
        { term: 'Search notes...', text: 'finds folders and notes by name or by what is written inside.' },
        { term: 'The note', text: 'tap a note to open it. Give it a title and write in the main box. A bar of tools lets you set the text size, bold, italic, strike-through, lists, alignment, indent and tables. Press ‹ Back to Notes when you are done.' },
        { term: '✕', text: 'deletes a note or a whole folder with everything in it. You are asked "Are you sure?" first.' },
      ],
    },
    {
      heading: 'Files',
      body: [
        'Your own folders and files, starting at Home. The first time, it makes five folders for you (Social, Health, Admin, Personal, Economic), each with Projects, Areas, Resources, Tasks and Systems inside.',
        'Tap a folder to go in. Tap a name in the line above the list to jump back. Tap ↻ to reload.',
        '+ File and + Image add things from your phone. They only appear once you are inside a folder. + Folder makes a new folder where you are.',
        'Tap a file to see its name, size and type. Long-press a folder to Rename or Delete it. Long-press a file to Open or Delete it. Deleting is permanent, and a folder takes everything inside it.',
      ],
    },
    {
      heading: 'Records',
      body: ['A record of what the filing helper did and what it was not sure about. Four tabs.'],
      items: [
        { term: 'Index', text: 'your Google Drive folders. This only fills in if Google Drive is connected on the web. If not, it says so.' },
        { term: 'Move Log', text: 'the latest 50 files that were moved: where from and to, why, when, and how sure it was. The small label says how it was decided: rule, ai, or user_override (you).' },
        { term: 'Review', text: 'files it was unsure about. A red number on the tab counts the ones waiting. Each shows where it came from and where the AI suggests putting it. Accept moves it there. Override lets you type a different folder, then Move Here.' },
        { term: 'Run History', text: 'each time it ran: how many files it Processed, Moved and Flagged for you to review.' },
      ],
    },
    {
      heading: 'Recall',
      body: [
        'Timed reminders. The list shows each one with a switch to turn it on or off, its time, its sound and how many times it plays. Tap a recall to edit it. Tap ✕ to delete it. Press + New to make one.',
        'A recall has a Title, a Time (24-hour, like 08:00) and a Repeat. Tap the day circles (M T W R F S U) to repeat on those days. All seven means every day. Pick none and it happens once, and you can add a date as YYYY-MM-DD.',
        'Pick a Sound from the preset list or your custom sounds, and press ▶ Test sound to hear it. Cycles is how many times the sound plays. Press Create Recall (or Update Recall) to save.',
        'This screen saves your recalls and lets you test the sound. It does not ring on the phone by itself.',
      ],
    },
    {
      heading: 'Saving',
      body: [
        'Notes save by themselves a moment after you stop typing.',
        'Folders, moves, switches and deletes take effect straight away.',
        'A recall needs Create Recall or Update Recall.',
      ],
    },
  ],
};
